import { render, staticRenderFns } from "./ComprobanteIngresoPage.vue?vue&type=template&id=793a0113"
import script from "./ComprobanteIngresoPage.js?vue&type=script&lang=js&external"
export * from "./ComprobanteIngresoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports